<template>
  <div class="login-wrapper">
    <div class="login-header">
      <img src="@/assets/hw_logo.png" alt="" width="54" class="login-logo" />
      <span class="name">北京一三城市环境管理有限公司</span>
    </div>
    <div class="login-content">
      <div class="login-box">
        <img src="@/assets/login.png" alt="" width="583" style="width:583px;height:460px" class="fl" />
        <div class="login-contrl fl">
          <div class="contrl-title">欢迎登录</div>
          <Form :model="login" :rules="loginRules" ref="user">
            <FormItem prop="userName">
              <Input v-model="login.userName" placeholder="请输出工作手机号"></Input>
            </FormItem>
            <FormItem prop="password">
              <Input v-model="login.password" type="password" placeholder="请输入密码" @keyup.enter.native="handleCheck"></Input>
            </FormItem>
<!--            <FormItem prop="verificationCode" v-if="checkStatus === 1">-->
<!--              <Input v-model="login.verificationCode" placeholder="请输入验证码" @keyup.enter.native="handleCheck" style="width: 55%;margin-right: 5px;"></Input>-->
<!--              <a v-show="verificationStatus" type="text" style="color: #CFA868;float: right;font-size: 16px;line-height: 3;" @click="sendVerification">获取验证码</a>-->
<!--              <a v-show="!verificationStatus" type="text" style="color: #CFA868;float: right;font-size: 16px;line-height: 3;">{{ codeTime }}秒后重新获取</a>-->
<!--            </FormItem>-->
          </Form>

          <Button type="primary" long class="" @click="handleCheck" style="background:#008690;border-color:#008690">登录</Button>
          <!--          <a style="float: right;margin-top: 8px;border-bottom: 1px solid #CFA868;line-height: 1;"-->
          <!--             href="javascript:void(0)" @click.stop="forgetPassword">忘记密码</a>-->
        </div>
      </div>
    </div>
    <div class="bottom_layer">
      <p class="lh">
        <a href="http://www.13hjing.com/h5/userPolicy.html" style="font-size: 13px">隐私政策 </a>|
        <a href="http://www.13hjing.com/h5/privacyPolicy.html" style="font-size: 13px"> 服务协议</a>
      </p>
    </div>
    <update-password :n="n"></update-password>
  </div>
</template>

<script type="text/ecmascript-6">
import UpdatePassword from './UpdatePassword'
import {loginPerCheck, sendVerification, checkVerification} from '../../api/login'

export default {
  name: 'login',
  components: {
    UpdatePassword
  },
  data() {
    return {
      verificationStatus: true,
      checkStatus: 0,
      codeTime: 60,
      n: 0,
      login: {
        userName: '',
        password: '',
        verificationCode: ''
      },
      loginRules: {
        userName: [
          {required: true, message: '请填写用户名', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请填写密码', trigger: 'blur'}
        ],
        verificationCode: [
          {required: true, message: '请填写验证码', trigger: 'blur'}
        ]
      },
    }
  },
  methods: {
    forgetPassword() {
      this.n++
    },
    sendVerification() {
      let params = {
        userName: this.login.userName
      }
      sendVerification(params).then(res => {
        if (res.data === true) {
          this.verificationStatus = false
          var codeTimeTimer = setInterval(() => {
            this.codeTime--;
            if (this.codeTime <= 0) {
              this.verificationStatus = true;
              clearInterval(codeTimeTimer);
              this.codeTime = 60
            }
          }, 1000);
        }
      })
    },
    handleCheck() {
      this.$refs['user'].validate(bool => {
        if (bool) {
          this.handleLogin()
          // if (this.checkStatus === 1) {
            // let params = {
            //   userName: this.login.userName,
            //   verificationCode: this.login.verificationCode
            // }
            // checkVerification(params).then(res => {
            //   if (res.data === true) {
            //     this.handleLogin()
            //   }
            // })
          // }
          // if (this.checkStatus === 0) {
          //   let params = {
          //     userName: this.login.userName,
          //     password: this.login.password
          //   }
          //   loginPerCheck(params).then(res => {
          //     if (res.data === true) {
          //       this.checkStatus = 1
          //     }
          //   })
          // }
        }
      })
    },
    handleLogin() {
      this.$refs['user'].validate(async bool => {
        if (!bool) {
          return
        }
        try {
          await this.$store.dispatch('Login', this.login)
          let autrority = await this.$store.dispatch('getAuthority')
          await this.$store.dispatch('GenerateRoutes', this.$store.getters.menuList)
          if (this.$store.getters.addRouters.length) {
            this.$router.addRoutes(this.$store.getters.addRouters)
            // await this.$store.dispatch('ProjectList')
            // await this.$store.dispatch('Userinfo')
            // await this.$store.dispatch('GetProjectByCondiction')
            // await this.$store.dispatch('GetProjectListCondiction')
            this.$router.push({name: this.$store.getters.addRouters[0].name});
          } else {
            // return Promise.reject('没有菜单权限')
            this.$Message.info('没有菜单权限')
          }


        } catch (e) {
          this.$Message.info(e)
        }

        // this.$store.dispatch('Login', this.login).then(res => {
        //   this.$store.dispatch('getAuthority').then(res => {
        //     this.$store.dispatch('GenerateRoutes', this.$store.getters.menuList)
        //     if (this.$store.getters.addRouters.length) {
        //       this.$router.addRoutes(this.$store.getters.addRouters)
        //       this.$router.push({name: this.$store.getters.addRouters[0].name});
        //     } else {
        //       return Promise.reject('没有菜单权限')
        //     }
        //
        //   }).catch(error => {
        //     this.$Message.info(error)
        //
        //   })
        //
        // }).catch(error => {
        // })
      })
    }
  }
}
</script>

<style lang="css" scoped>
.login-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
}

.login-header {
  /*height: 72px;*/
  line-height: 72px;
  font-size: 0;
  margin-top: 20px;
  /*box-shadow: 0 1px 0 0 #F4F4F4;*/
}

.login-content {
  flex: 1;
  /*background-color: #fbfbfb;*/
}

.login-logo {
  vertical-align: middle;
  height: 57px;
  width: 54px;
  margin-left: 30px;
  margin-right: 10px;
}

.name {
  font-size: 24px;
  vertical-align: middle;
  font-weight: bold;
  font-family: PingFangSC-Semibold, sans-serif;
}

.login-box {
  display: table;
  margin: 5% auto 0;
}

.login-contrl {
  width: 376px;
  height: 400px;
  padding: 40px 46px 0;
  background: #ffffff;
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  margin-left: 10px;
  margin-top: 60px;
}

.contrl-title {
  font-size: 16px;
  margin-bottom: 44px;
}

.login-btn {
  margin-top: 20px;
}
.bottom_layer{
  width: 100%;
  position: fixed;
  z-index: 302;
  bottom: 0;
  left: 0;
  height: 39px;
  padding-top: 1px;
  overflow: hidden;
  zoom: 1;
  margin: 0;
  line-height: 39px;
  background: #fff;
  text-align: center;
}
#bottom_layer .lh {
  display: inline;
  margin-right: 20px;
}
</style>
